import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const sectionHeading = css({
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
});

export const totalAmount = css({
  fontSize: 'heading-sm',
  fontWeight: 'bold',
  color: 'text.accent.brand.hero',
  lineHeight: 'heading-sm',
  overflowWrap: 'anywhere',
  lg: {
    fontSize: 'heading-md',
    lineHeight: 'heading-md',
  },
});

export const totalLabel = css({
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  color: 'text.neutral',
  fontWeight: 'bold',
  marginBottom: 'tighter',
});

export const summaryList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
  margin: 0,
});

export const summaryRow = css({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto',
  columnGap: 'default',
  alignItems: 'baseline',
  paddingBlock: 'tightest',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const summaryLabel = css({
  color: 'text.subtle',
});

export const summaryValue = css({
  margin: 0,
  fontWeight: 'bold',
  color: 'text.neutral',
  textAlign: 'right',
});

export const leaseTermsText = css({
  fontSize: 'body',
  lineHeight: 'body',
  color: 'text.neutral',
  margin: 0,
});

export const footerContainer = css({
  marginTop: 'default',
});
